import styled from 'styled-components';

export const TrashContainer = styled.div`
  margin: auto;
  height: 15px;
  width: 15px;
  cursor: pointer;

  &:hover .tap {
    transform: rotate(45deg) translate(0, -150%);
    transition: transform 500ms ease-in-out;
  }

  &:hover .trash-part {
    background: #ff6873;
    transition: background 300ms ease-in-out;
  }
`;

export const Trash = styled.div`
  width: 100%;
  height: 100%;
  margin-left: auto;
  margin-right: auto;
`;

export const Tap = styled.div`
  width: 100%;
  height: 15%;
  overflow: hidden;
  transform: rotate(0deg) translate(0);
  transition: transform 300ms ease-in-out;
`;

export const Tap2 = styled.div`
  width: 100%;
  height: 85%;
  overflow: hidden;
`;

export const TrashPart = styled.div`
  background: #BE8976;
  transition: background 300ms ease-in-out;
`;

export const Tip = styled(TrashPart)`
  width: 15%;
  height: 30%;
  margin-left: auto;
  margin-right: auto;
  border-top-right-radius: 3px;
  border-top-left-radius: 3px;
`;

export const Top = styled(TrashPart)`
  margin-top: 1%;
  width: 80%;
  height: 70%;
  margin-left: auto;
  margin-right: auto;
  border-top-right-radius: 3px;
  border-top-left-radius: 3px;
`;

export const Bottom = styled(TrashPart)`
  width: 70%;
  height: 98%;
  margin-top: 2%;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  justify-content: space-around;
  border-bottom-right-radius: 3px;
  border-bottom-left-radius: 3px;
`;

export const Line = styled.div`
  margin: auto;
  background-color: white;
  height: 70%;
  width: 2px;
`; 